// Generated by CoffeeScript 2.7.0
// TLDR; This is stripped down from the IAB ad block detection library.
// https://github.com/InteractiveAdvertisingBureau/AdBlockDetection
// The aforementioned library is not well maintained
// and had work in progress network adblocking detection
var init = function () {
    var ofs = 'offset', cl = 'client';
    var noop = function () { };
    var testedOnce = false;
    var testExecuting = false;
    var isOldIEevents = window.addEventListener === undefined;
    /**
     * Options set with default options initialized
     *
     */
    var _options = {
        loopDelay: 50,
        maxLoop: 5,
        debug: false,
        found: noop,
        notfound: noop,
        complete: noop,
    };
    var listeners = []; // event response listeners
    var baitNode = null;
    var quickBait = {
        cssClass: 'ad-slot pub_300x250 pub_300x250m pub_728x90 text-ad textAd text_ad text_ads text-ads text-ad-links',
    };
    var baitTriggers = {
        nullProps: [ofs + 'Parent'],
        zeroProps: [],
    };
    baitTriggers.zeroProps = [
        ofs + 'Height',
        ofs + 'Left',
        ofs + 'Top',
        ofs + 'Width',
        ofs + 'Height',
        cl + 'Height',
        cl + 'Width',
    ];
    // result object
    var exeResult = {
        quick: null,
        remote: null,
    };
    var findResult = null; // result of test for ad blocker
    var timerIds = {
        test: 0,
        download: 0,
    };
    function isFunc(fn) {
        return typeof fn == 'function';
    }
    /**
     * Make a DOM element
     */
    function makeEl(tag, attributes) {
        var k, v, el, attr = attributes;
        var d = document;
        el = d.createElement(tag);
        if (attr) {
            for (k in attr) {
                if (attr.hasOwnProperty(k)) {
                    el.setAttribute(k, attr[k]);
                }
            }
        }
        return el;
    }
    function attachEventListener(dom, eventName, handler) {
        if (isOldIEevents) {
            dom.attachEvent('on' + eventName, handler);
        }
        else {
            dom.addEventListener(eventName, handler, false);
        }
    }
    function log(message, isError) {
        if (!_options.debug && !isError) {
            return;
        }
        if (window.console && window.console.log) {
            if (isError) {
                console.error('[ABD] ' + message);
            }
            else {
                console.log('[ABD] ' + message);
            }
        }
    }
    function beginTest(bait) {
        log('start beginTest');
        if (findResult == true) {
            return;
        }
        testExecuting = true;
        castBait(bait);
        exeResult.quick = 'testing';
        timerIds.test = setTimeout(function () {
            reelIn(bait, 1);
        }, 5);
    }
    /**
     * Create the bait node to see how the browser page reacts
     */
    function castBait(bait) {
        var i, d = document, b = d.body;
        var t;
        var baitStyle = 'width: 1px !important; height: 1px !important; position: absolute !important; left: -10000px !important; top: -1000px !important;';
        if (bait == null || typeof bait == 'string') {
            log('invalid bait being cast');
            return;
        }
        if (bait.style != null) {
            baitStyle += bait.style;
        }
        baitNode = makeEl('div', {
            class: bait.cssClass,
            style: baitStyle,
        });
        log('adding bait node to DOM');
        b.appendChild(baitNode);
        // touch these properties
        for (i = 0; i < baitTriggers.nullProps.length; i++) {
            t = baitNode[baitTriggers.nullProps[i]];
        }
        for (i = 0; i < baitTriggers.zeroProps.length; i++) {
            t = baitNode[baitTriggers.zeroProps[i]];
        }
    }
    /**
     * Run tests to see if browser has taken the bait and blocked the bait element
     */
    function reelIn(bait, attemptNum) {
        var i, k, v;
        var body = document.body;
        var found = false;
        if (baitNode == null) {
            log('recast bait');
            castBait(bait || quickBait);
        }
        if (typeof bait == 'string') {
            log('invalid bait used', true);
            if (clearBaitNode()) {
                setTimeout(function () {
                    testExecuting = false;
                }, 5);
            }
            return;
        }
        if (timerIds.test > 0) {
            clearTimeout(timerIds.test);
            timerIds.test = 0;
        }
        // test for issues
        if (body.getAttribute('abp') !== null) {
            log('found adblock body attribute');
            found = true;
        }
        for (i = 0; i < baitTriggers.nullProps.length; i++) {
            if (baitNode[baitTriggers.nullProps[i]] == null) {
                if (attemptNum > 4)
                    found = true;
                log('found adblock null attr: ' + baitTriggers.nullProps[i]);
                break;
            }
            if (found == true) {
                break;
            }
        }
        for (i = 0; i < baitTriggers.zeroProps.length; i++) {
            if (found == true) {
                break;
            }
            if (baitNode[baitTriggers.zeroProps[i]] == 0) {
                if (attemptNum > 4)
                    found = true;
                log('found adblock zero attr: ' + baitTriggers.zeroProps[i]);
            }
        }
        if (window.getComputedStyle !== undefined) {
            var baitTemp = window.getComputedStyle(baitNode, null);
            if (baitTemp.getPropertyValue('display') == 'none' ||
                baitTemp.getPropertyValue('visibility') == 'hidden') {
                if (attemptNum > 4)
                    found = true;
                log('found adblock computedStyle indicator');
            }
        }
        testedOnce = true;
        if (found || attemptNum++ >= _options.maxLoop) {
            findResult = found;
            log('exiting test loop - value: ' + findResult);
            notifyListeners();
            if (clearBaitNode()) {
                setTimeout(function () {
                    testExecuting = false;
                }, 5);
            }
        }
        else {
            timerIds.test = setTimeout(function () {
                reelIn(bait, attemptNum);
            }, _options.loopDelay);
        }
    }
    function clearBaitNode() {
        if (baitNode === null) {
            return true;
        }
        try {
            if (isFunc(baitNode.remove)) {
                baitNode.remove();
            }
            document.body.removeChild(baitNode);
        }
        catch (ex) { }
        baitNode = null;
        return true;
    }
    /**
     * Halt the test and any pending timeouts
     */
    function stopFishing() {
        if (timerIds.test > 0) {
            clearTimeout(timerIds.test);
        }
        if (timerIds.download > 0) {
            clearTimeout(timerIds.download);
        }
        clearBaitNode();
    }
    /**
     * Fire all registered listeners
     */
    function notifyListeners() {
        var i, funcs;
        if (findResult === null) {
            return;
        }
        for (i = 0; i < listeners.length; i++) {
            funcs = listeners[i];
            try {
                if (funcs != null) {
                    if (isFunc(funcs['complete'])) {
                        funcs['complete'](findResult);
                    }
                    if (findResult && isFunc(funcs['found'])) {
                        funcs['found']();
                    }
                    else if (findResult === false && isFunc(funcs['notfound'])) {
                        funcs['notfound']();
                    }
                }
            }
            catch (ex) {
                log('Failure in notify listeners ' + ex.Message, true);
            }
        }
    }
    /**
     * Attaches event listener or fires if events have already passed.
     */
    function attachOrFire() {
        var fireNow = false;
        var fn;
        if (document.readyState) {
            if (document.readyState == 'complete') {
                fireNow = true;
            }
        }
        fn = function () {
            beginTest(quickBait, false);
        };
        if (fireNow) {
            fn();
        }
        else {
            attachEventListener(window, 'load', fn);
        }
    }
    /**
     * Public interface of adblock detector
     */
    return function (options) {
        var k, v, funcs;
        if (!options) {
            return;
        }
        funcs = {
            complete: noop,
            found: noop,
            notfound: noop,
        };
        for (k in options) {
            if (options.hasOwnProperty(k)) {
                if (k == 'complete' || k == 'found' || k == 'notFound') {
                    funcs[k.toLowerCase()] = options[k];
                }
                else {
                    _options[k] = options[k];
                }
            }
        }
        listeners.push(funcs);
        attachOrFire();
    };
};
export default {
    init: init(),
};
